import {
  RadioOption,
  transformToYesOrNoString,
} from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

export const getOrderPolicyAcceptanceRequired = ({
  orderPolicyId,
  orderPolicyAcceptanceRequired,
}: {
  orderPolicyId: string | null;
  orderPolicyAcceptanceRequired: boolean | undefined;
}): RadioOption =>
  orderPolicyId && orderPolicyAcceptanceRequired !== undefined
    ? transformToYesOrNoString(orderPolicyAcceptanceRequired)
    : null;
